/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-07-11
 */

import React from 'react';
import './App.scss';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Home } from './pages/Home';
import { Contact } from './pages/Contact';
import { Donate } from './pages/Donate';
import { Deceased } from './pages/Deceased';
import { TreeOfLife } from './pages/TreeOfLife';
import { Search } from './pages/Search';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { TermsAndConditions } from './pages/TermsAndConditions';
import { Subscriptions } from './pages/Subscriptions';
import { GriefSupport } from './pages/Resources';

function App() {
  return (
      <BrowserRouter>
        <Header />
          <Switch>
            <Route  path="/" component={Home} exact />
            <Route path="/contact" component={Contact} />
            <Route path="/deceased/:deceasedId" component={Deceased} />
            <Route path="/tree-of-life/:deceasedId" component={TreeOfLife} />
            <Route path="/donate" component={Donate} />
            <Route path="/search" component={Search} />
            <Route path="/resources" component={GriefSupport} />
            <Route path="/terms-conditions" component={TermsAndConditions} />
            <Route path="/subscriptions/:subscriberId" component={Subscriptions} />
          </Switch>
        <Footer />
      </BrowserRouter>
  );
}

export default App;
